import React from "react";
import { useLottie } from "lottie-react";
import { Clock, CheckCircle, Eye } from "lucide-react";

const ApplicationStatus = ({ applicationData, onViewEvaluation }) => {
    if (!applicationData) {
        return null;
    }

    // Evaluated, show nothing
    if (applicationData.isEvaluated) {
        return;
    }

    // Pending Evaluation Status (default when not evaluated)
    return (
        <div className="max-w-2xl mx-auto text-center py-6 sm:py-12">
            {/* Lottie Animation for Pending */}
            <div className="w-48 h-48 sm:w-64 sm:h-64 mx-auto mb-4 sm:mb-6">
                <PendingLottie />
            </div>

            <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-4 sm:p-8">
                <h3 className="text-xl sm:text-2xl font-bold text-yellow-800 mb-3 sm:mb-4">
                    Application Under Evaluation
                </h3>
                <p className="text-yellow-700 text-base sm:text-lg mb-4 sm:mb-6">
                    Your application has been successfully submitted and is currently being evaluated by our team.
                    You'll receive an email notification once the evaluation is complete.
                </p>
                <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-2 bg-yellow-100 rounded-full text-yellow-800 font-medium text-sm sm:text-base">
                    <Clock className="w-3 h-3 sm:w-4 sm:h-4" />
                    Status: Pending Evaluation
                </div>
            </div>
        </div>
    );
};

const PendingLottie = () => {
    const options = {
        path: "/animations/pending.json",
        loop: true,
        autoplay: true
    };
    const { View } = useLottie(options);
    return <>{View}</>;
};

const ApprovedLottie = () => {
    const options = {
        path: "/animations/approved.json",
        loop: true,
        autoplay: true
    };
    const { View } = useLottie(options);
    return <>{View}</>;
};

const RejectedLottie = () => {
    const options = {
        path: "/animations/rejected.json",
        loop: true,
        autoplay: true
    };
    const { View } = useLottie(options);
    return <>{View}</>;
};

export default ApplicationStatus;